export default __webpack_public_path__ + "static/media/hero-workers.63fa90e9.png";